import { Task, TaskStatus } from "datamodel/task";

const isTaskInProgress = (task: Task): boolean =>
  task.properties.status === TaskStatus.LabelingInProgress ||
  task.properties.status === TaskStatus.ValidationInProgress;

export default isTaskInProgress;
